import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { configURI, configURI2 } from '../../../shared/apiUrlConfig';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';

@Injectable()

export class MaindashboardService {
  url = environment.configURI;
  /*private agentsComplList = new BehaviorSubject<any>();
  complList = this.agentsComplList.asObservable();*/
  // httpClientHeaderOptions = {
  //   headers: new HttpHeaders({
  //     'x-access-token': localStorage.getItem('Token'),
  //     'Cache-Control': 'no-cache',
  //     'Pragma': 'no-cache',
  //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
  //   })
  // };
  constructor(private httpClient: HttpClient,
              public userFriendlyMsgs: UserFriendlyMsgs) { }


  //  public getAllcompliants(){
  //    return this.httpClient.get(this.url + '/mainDashboard/getdocuments').catch(this.userFriendlyMsgs.errorHandler);
  //  }

  // public getAllCompliantAgents(platinum) {
  //   // this.httpClientHeaderOptions = {
  //   //   headers: new HttpHeaders({
  //   //     'x-access-token': localStorage.getItem('Token'),
  //   //     'Cache-Control': 'no-cache',
  //   //     'Pragma': 'no-cache',
  //   //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
  //   //   })
  //   // };
  //   //this.httpClientHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
  //   return this.httpClient.get(this.url + '/mainDashboard/getdocuments?'+'platinum='+platinum).catch(this.userFriendlyMsgs.errorHandler);
  // }

  public getCompliantAgentsByRegionId(regionId, platinum, days) {
    // this.httpClientHeaderOptions = {
    //   headers: new HttpHeaders({
    //     'x-access-token': localStorage.getItem('Token'),
    //     'Cache-Control': 'no-cache',
    //     'Pragma': 'no-cache',
    //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    //   })
    // };
    //this.httpClientHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
    if (regionId !== 'All' && platinum !=='') {
      return this.httpClient.get(this.url+'/mainDashboard/getdocuments?'+'platinum='+platinum+'&regionid='+regionId+'&noOfDays='+days).catch(this.userFriendlyMsgs.errorHandler);
    } else if (regionId === 'All' && platinum !=='') {
      return this.httpClient.get(this.url+'/mainDashboard/getdocuments?'+'platinum='+platinum+'&noOfDays='+days).catch(this.userFriendlyMsgs.errorHandler);
    }
  }

  public getPendingRequestList(status){    
    return this.httpClient.get(this.url + '/vendors/employees?status=' + status).catch(this.userFriendlyMsgs.errorHandler);
  }

  public getPendingApprovalsList(status){
    return this.httpClient.get(this.url + '/mainDashboard/getpendingdocuments?status=' + status).catch(this.userFriendlyMsgs.errorHandler);
  }

  public getRemediationList(){
    return this.httpClient.get(this.url + '/dashboard/remediation').catch(this.userFriendlyMsgs.errorHandler);
  }

  public getRemediationCount(){
    return this.httpClient.get(this.url + '/regions/remediation/count').catch(this.userFriendlyMsgs.errorHandler);
  }
  public getListOfRemediations(RegionId){
    return this.httpClient.get(this.url + '/dashboard/remediation?region=' + RegionId).catch(this.userFriendlyMsgs.errorHandler);
  }
  /*public handleError(error: any): Promise<any> {
    
    return Promise.reject(error.message || error);
  }

  public extractData(res: HttpResponse<object>) {
    return res;
  }*/
}



// WEBPACK FOOTER //
// ./src/app/services/maindashboard/maindashboard.service.ts